import { ArrowRight, Phone, CalendarCheck } from "lucide-react";
import { APPLY_URL, BOOK_URL, FAMILY_IMAGE, PHONE_NUMBER, PHONE_TEL } from "@/lib/site";

export default function PreFooterCTA() {
  return (
    <section
      data-testid="prefooter-cta-section"
      className="relative isolate overflow-hidden"
    >
      <div className="absolute inset-0 -z-10">
        <img
          src={FAMILY_IMAGE}
          alt="Happy family near home"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A2F6B] via-[#0A2F6B]/95 to-[#0A2F6B]/70" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 lg:py-32">
        <div className="max-w-3xl">
          <p className="text-xs font-semibold tracking-[0.22em] uppercase text-[#F26A21] mb-3">
            Ready when you are
          </p>
          <h2 className="font-display font-extrabold text-white text-3xl md:text-4xl lg:text-5xl xl:text-6xl leading-[1.1] tracking-tight">
            Unlock the equity you&rsquo;ve built.
            <span className="block text-[#F26A21] mt-2">On your terms.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-white/80 leading-relaxed max-w-xl">
            Apply online in minutes or speak with Randy Wilson directly. There&rsquo;s no obligation
            &mdash; just clear answers about whether a HELOC is right for you.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href={APPLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="prefooter-apply-button"
              className="inline-flex items-center justify-center gap-2 bg-[#F26A21] hover:bg-[#D95A1A] text-white font-semibold text-base px-7 py-4 rounded-md shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200"
            >
              Apply Now
              <ArrowRight size={18} strokeWidth={2.5} />
            </a>
            <a
              href={BOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="prefooter-book-button"
              className="inline-flex items-center justify-center gap-2 bg-white hover:bg-[#F1F5F9] text-[#0A2F6B] font-semibold text-base px-7 py-4 rounded-md shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-200"
            >
              <CalendarCheck size={18} strokeWidth={2.5} />
              Book a Meeting
            </a>
            <a
              href={PHONE_TEL}
              data-testid="prefooter-phone-button"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/15 backdrop-blur-sm border border-white/30 text-white font-semibold text-base px-7 py-4 rounded-md transition-all duration-200"
            >
              <Phone size={18} strokeWidth={2.5} />
              <span className="tabular-nums">{PHONE_NUMBER}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
